import { useStore } from 'vuex';
import GET_RECOMMENDATIONS from '../type/actions';
import constants from '../utils/constants';

export const recipesIdsKillSwitchList = {
  [constants.ENTRY_POINT.MCOM]: [
    {
      recipeId: '605-21',
      ksName: 'filterOverlappingProsProducts',
    },
    {
      recipeId: '1041-21',
      ksName: 'showPriceOverlay',
    },
    {
      recipeId: '1140-21',
      ksName: 'isProsOpenInNewTabEnabled',
    },
  ],
  [constants.ENTRY_POINT.BCOM]: [
    {
      recipeId: '1139-21',
      ksName: 'isProsOpenInNewTabEnabled',
    },
  ],
};

export const updateConfig = async ({
  _config, _properties = {}, expSdk,
}) => {
  const entryPoint = process.env.ENTRY_POINT;
  let setupConfig;
  let setKillSwitchUsingExperimentation;
  try {
    const module1 = await import(
      `../recommendation/${entryPoint}/config/config`
    );
    setupConfig = module1.default;
    const module2 = await import('../utils/killSwitchUtil');
    setKillSwitchUsingExperimentation = module2.setKillSwitchUsingExperimentation;
  } catch (err) {
    throw new Error('Module load failed');
  }

  const { config, properties } = setupConfig(_config, _properties);
  recipesIdsKillSwitchList[entryPoint].forEach((item) => {
    setKillSwitchUsingExperimentation(
      item.recipeId,
      item.ksName,
      properties,
      expSdk,
    );
  });
  return { config, properties };
};

export const useProsCollection = ({
  config, properties = {}, store = useStore(),
}) => {
  store
    .dispatch(`recommendationStore/${GET_RECOMMENDATIONS}`, {
      config,
      properties,
    })
    .then(() => {
      // TODO: Analyic tag
    })
    .catch(() => {
      // TODO: Error message Throw
    });

  return { config, properties };
};

// export default useProsCollection;
